var features = {};

function register(name, ctor) {
  features[name] = ctor;
}

function get(name) {
  return features[name];
}

exports.register = register;
exports.get = get;


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/toolbox/featureManager.js
// module id = dCQY
// module chunks = 0 1